document.addEventListener('DOMContentLoaded', () => {
    const variantsForm = document.querySelector('#wimmelbuch-product-form');
    if (!variantsForm) return;

    const featuredImages = document.querySelectorAll('[data-featured-image]');
    const price = document.querySelector('.book-product__price');
    const compareAtPrice = document.querySelector('.book-product__compare-at-price');
    const saveBadge = document.querySelector('.book-product__save-badge');

    variantsForm.addEventListener('change', (event) => {
        const target = event.target.value !== undefined?event.target: variantsForm.querySelector('input:checked');
        
        if (target.hasAttribute('data-price') && price) price.innerHTML = target.getAttribute('data-price');
        if (target.hasAttribute('data-compare-at-price') && compareAtPrice) compareAtPrice.innerHTML = target.getAttribute('data-compare-at-price');
        
        if (target.hasAttribute('data-save-price') && saveBadge){
            saveBadge.innerHTML = target.getAttribute('data-save-price');
        } 
        else if(saveBadge && !target.hasAttribute('data-save-price')) {
            saveBadge.innerHTML = '';
        }

        if (target.hasAttribute('data-image')) {

            featuredImages.forEach(imageWrapper => {
                const image = imageWrapper.querySelector('img');
                if (!image) return;
                image.src = image.src.replaceAll(imageWrapper.getAttribute('data-featured-image'), target.getAttribute('data-image'));
                image.srcset = image.srcset.replaceAll(imageWrapper.getAttribute('data-featured-image'), target.getAttribute('data-image'))
                imageWrapper.setAttribute('data-featured-image', target.getAttribute('data-image'));
            });
        }

        window.history.replaceState({ }, '', `${window.routes.productUrl}?variant=${target.value}`);
    })

    variantsForm.dispatchEvent(new Event('change'));
})